import React from "react";
import { Card, CardBody, CardHeader } from "reactstrap";

const RenewalChart = ({ data = [] }) => {
    // Caso não venha dado (ainda carregando), default vázio mas não quebra
    const chartData = data && data.length > 0 ? data : [
        { month: "JAN.", current: 0, previous: 0 },
        { month: "FEV.", current: 0, previous: 0 },
        { month: "MAR.", current: 0, previous: 0 },
        { month: "ABR.", current: 0, previous: 0 },
        { month: "MAI.", current: 0, previous: 0 },
        { month: "JUN.", current: 0, previous: 0 },
        { month: "JUL.", current: 0, previous: 0 },
        { month: "AGO.", current: 0, previous: 0 },
        { month: "SET.", current: 0, previous: 0 },
        { month: "OUT.", current: 0, previous: 0 },
        { month: "NOV.", current: 0, previous: 0 },
        { month: "DEZ.", current: 0, previous: 0 }
    ];

    // Calcula o valor máximo (current ou previous) de todo o dataset para escalonar
    const maxNumber = Math.max(
        ...chartData.map(item => Math.max(item.current || 0, item.previous || 0)),
        1 // Evita divisão por zero
    );
    
    // Deixa uma sobra de 20% pro gráfico não encostar no teto
    const maxValue = maxNumber * 1.2;

    return (
        <Card className="border-0 shadow-sm h-100" style={{ borderRadius: "4px" }}>
            <CardHeader className="bg-white border-0 pt-4 px-4 pb-0">
                <div className="d-flex justify-content-between align-items-center">
                    <h6 className="text-uppercase fw-bold m-0 text-primary" style={{ fontSize: "11px", letterSpacing: "1px" }}>Volume de Renovações</h6>
                    <div className="d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center gap-1">
                            <span className="rounded" style={{ width: "12px", height: "12px", backgroundColor: "#A0C4FF" }} />
                            <small className="text-muted fw-bold" style={{ fontSize: "11px" }}>Ano Atual</small>
                        </div>
                        <div className="d-flex align-items-center gap-1">
                            <span className="rounded" style={{ width: "12px", height: "12px", backgroundColor: "#E9F2FF" }} />
                            <small className="text-muted fw-bold" style={{ fontSize: "11px" }}>Ano Anterior</small>
                        </div>
                    </div>
                </div>
            </CardHeader>
            <CardBody className="p-4 mt-2">
                <div style={{ height: "185px", display: "flex", alignItems: "flex-end", position: "relative", gap: "2px" }}>
                    {/* Y-axis Labels */}
                    <div style={{ position: "absolute", left: -5, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between", fontSize: "11px", color: "#adb5bd", fontWeight: "600" }}>
                        <span>30</span>
                        <span>25</span>
                        <span>20</span>
                        <span>15</span>
                        <span>10</span>
                        <span>5</span>
                        <span>0</span>
                    </div>

                    <div className="flex-grow-1 d-flex h-100 ps-4 pt-1" style={{ borderBottom: "1px solid #eff2f7" }}>
                        {chartData.map((item, idx) => (
                            <div key={idx} className="flex-grow-1 h-100 d-flex flex-column align-items-center px-1">
                                <div className="d-flex h-100 align-items-end" style={{ gap: "4px" }}>
                                    <div 
                                        style={{ 
                                            width: "12px", 
                                            height: `${(item.current / maxValue) * 100}%`, 
                                            backgroundColor: "#A0C4FF", 
                                            borderRadius: "4px 4px 0 0",
                                            minHeight: "2px"
                                        }} 
                                    />
                                    <div 
                                        style={{ 
                                            width: "12px", 
                                            height: `${(item.previous / maxValue) * 100}%`, 
                                            backgroundColor: "#E9F2FF", 
                                            borderRadius: "2px 2px 0 0",
                                            minHeight: "2px"
                                        }} 
                                    />
                                </div>
                                <span className="mt-2 text-muted fw-bold" style={{ fontSize: "11px" }}>{item.month}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default RenewalChart;
